/**
 * Saved items（Save for later）のアカウント同期
 *
 * ログイン中の顧客は App Proxy（/apps/wishlist）経由で customer metafield と同期する。
 * 未ログインの場合は何もしないので、従来どおり localStorage だけで動く。
 *
 * 同期の考え方:
 *   このブラウザでこの顧客が初めて同期するとき … ローカル分とアカウント分を統合する
 *     （ログインした瞬間に手元の保存リストが消えるのを防ぐため）
 *   2回目以降 … アカウント側を正とする
 *     （他の端末で削除した内容が復活しないようにするため）
 *
 * 「初めて同期した」と記録するのは、アカウント側への保存が成功したときだけ。
 * また、アカウント側が空で手元に保存がある場合は上書きしない。
 * この2つが無いと、通信が一度失敗しただけで手元の保存が丸ごと消える。
 */
(function () {
  var STORAGE_KEY = 'onhow-wishlist';
  var SYNCED_KEY = 'onhow-wishlist-synced-customer';
  var ENDPOINT = '/apps/wishlist';
  var PUSH_DELAY = 500;

  var signedIn = false;
  var pushTimer = null;

  function read() {
    try {
      var value = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      return Array.isArray(value) ? value : [];
    } catch (e) {
      return [];
    }
  }

  function write(items) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  }

  function union(primary, secondary) {
    var seen = {};
    var out = [];
    var all = primary.concat(secondary);
    for (var i = 0; i < all.length; i++) {
      var item = all[i];
      var url = item && typeof item.url === 'string' ? item.url : '';
      if (!url || seen[url]) continue;
      seen[url] = true;
      out.push(item);
    }
    return out;
  }

  function sameList(a, b) {
    if (a.length !== b.length) return false;
    for (var i = 0; i < a.length; i++) {
      if ((a[i] && a[i].url) !== (b[i] && b[i].url)) return false;
    }
    return true;
  }

  // 保存できたかどうかを true / false で返す。
  // 呼び出し側は、この結果を見てから「同期済み」を記録すること。
  function post(items) {
    return fetch(ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items }),
    })
      .then(function (response) { return !!(response && response.ok); })
      .catch(function () { return false; });
  }

  // 保存内容が変わったときに呼ぶ（既存の保存・削除・復元処理から呼び出す）
  function push() {
    if (!signedIn) return;
    if (pushTimer) clearTimeout(pushTimer);
    pushTimer = setTimeout(function () { post(read()); }, PUSH_DELAY);
  }

  function notify() {
    document.dispatchEvent(new CustomEvent('wishlist:synced'));
  }

  function sync() {
    return fetch(ENDPOINT, { headers: { Accept: 'application/json' } })
      .then(function (response) { return response.ok ? response.json() : null; })
      .then(function (data) {
        if (!data || !data.signed_in) return false;

        signedIn = true;
        var server = Array.isArray(data.items) ? data.items : [];
        var local = read();
        var customerId = String(window.wanokaoriCustomerId || '');
        var firstSyncOnThisBrowser = localStorage.getItem(SYNCED_KEY) !== customerId;

        if (firstSyncOnThisBrowser) {
          var merged = union(server, local);
          write(merged);

          if (sameList(merged, server)) {
            // 送る必要がない（アカウント側と同じ内容）
            localStorage.setItem(SYNCED_KEY, customerId);
            notify();
            return true;
          }

          // 保存できたと確認できたときだけ「同期済み」を記録する。
          // 失敗したまま記録すると、次回この端末を開いたときに
          // 2回目以降の扱いになり、空のアカウント側で手元の保存が消える。
          return post(merged).then(function (saved) {
            if (saved) localStorage.setItem(SYNCED_KEY, customerId);
            notify();
            return true;
          });
        }

        if (!server.length && local.length) {
          // アカウント側が空で手元に保存がある場合は、上書きせずに送り直す。
          // 他の端末で全件削除した直後もここに入るが、
          // 消えたまま戻らないより、残ってしまうほうが害が小さい。
          post(local);
        } else if (!sameList(server, local)) {
          write(server);
        }

        notify();
        return true;
      })
      .catch(function () { return false; });
  }

  window.wanokaoriWishlistSync = {
    push: push,
    sync: sync,
    isSignedIn: function () { return signedIn; },
  };

  if (window.wanokaoriCustomerId) sync();
})();
